"use strict";

import CRowElement from './CRowElement';
import CType from './../CType';
import CLegendElement from './CLegendElement';

export default class DiffChart extends CType{

    constructor(){
        super();
        this._axisX=0;
        this._axisY=0;
    }

    addElement(element){
        this._elements.push(new CRowElement(element,this._axisX,this._axisY,this._width,this._config,this._inputManager));
        this._axisY+=30;
    }

    setElements(data){
        let me=this;
        this._data=data;
        this._data.forEach(function (item) {
            me.addElement(item);
        });

        this._axisY+=30;

        this._elements.push(new CLegendElement(this._axisX,this._axisY,this._width,this._config));
    }

}




// WEBPACK FOOTER //
// ./src/components/cchart/Template/DiffChart.js